<!-- Zweck: Stellt die HTML-Struktur für app global search box component im Frontend bereit. -->
<div class="globalSearchBoxBackground" [class.active]="focus" [class.mobile]="msvc.isMobile()|async"></div>
<div class="globalSearchBoxOuter" [class.focus]="focus" [class.mobile]="msvc.isMobile()|async" [class.hasResults]="(showResults|async) && (results|async)?.length > 1">
  <div class="globalSearchBox tut_global-search-box" (focusin)="focusIn()" (focusout)="focusOut()">
    <div class="inner">
      <mat-form-field appearance="outline" [style.width.px]="widthPx" [style.width.%]="widthPercent">
        <input matInput #globalSearchInput [(ngModel)]="searchValue" (keydown.f6)="$event.preventDefault(); $event.stopPropagation()" (keydown.enter)="search()" placeholder="Suche"
          (keyup)="keyUP()">

        <span matSuffix>
          @if (has_search && focus) {
            <button (click)="reset($event)" color="primary" class="reset-button" mat-icon-button matTooltip="Suchen"
              >
              <svg-icon>error-clean</svg-icon>
            </button>
          }
          <button mat-icon-button color="primary" (click)="search()" [disabled]="!searchReady">
            <svg-icon>suche</svg-icon>
          </button>
        </span>
      </mat-form-field>

      @if (showResults|async) {
        <div class="resultBox mat-elevation-z1">
          @if (!(results|async)) {
            <div class="infobox">
              <h3>Suche...</h3>
            </div>
          }
          @if ((results|async) && (results|async)?.length == 0) {
            <div class="infobox">
              <h3>Keine Treffer</h3>
            </div>
          }
          @if ((results|async) && (results|async)?.length >= 0) {
            <div>
              <table class="table-body-striped">
                @for (resultGroup of (results|async); track resultGroup; let last = $last; let first = $first) {
                  <tbody>
                    <tr [class.headerRow]="!first">
                      <td class="iconTd">
                        @if (resultGroup.icon) {
                          <svg-icon>{{resultGroup.icon}}</svg-icon>
                        }
                      </td>
                      <td colspan="3" class="resultGroup-label">
                        <div class="resultGroup-label">
                          {{resultGroup.label}}
                        </div>
                        @if (resultGroup.description) {
                          <div class="resultGroup-description">
                            {{resultGroup.description}}
                          </div>
                        }
                      </td>
                    </tr>
                    @for (resultEntry of resultGroup.entries; track resultEntry) {
                      <tr class="resultEntry" (click)="clickResultEntry(resultEntry)">
                        <td class="entrySpacerTd"></td>
                        <td class="entrySpacerTd"></td>
                        <td class="iconTd">
                          <svg-icon>{{resultEntry.icon}}</svg-icon>
                        </td>
                        <td>
                          <div class="result-label">
                            <table style="width: 100%">
                              <tr>
                                <td>
                                  {{resultEntry.label}}
                                </td>
                                @if (resultEntry.payload && resultEntry.payload.article) {
                                  <td style="text-align: right">
                                    <artikel-status-icon [showTooltip]="false" [artikel]="resultEntry.payload.article"></artikel-status-icon>
                                  </td>
                                }
                              </tr>
                            </table>
                          </div>
                          @if (resultEntry.description) {
                            <div  class="result-description">
                              {{resultEntry.description}}
                            </div>
                          }
                        </td>
                      </tr>
                    }
                    @if (!last) {
                      <tr>
                        <td colspan="4">&nbsp;</td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
